import { IconDefinition } from "./types";

const lock: IconDefinition = {
  iconName: "lock",
  width: 384,
  height: 512,
  svgPathData:
    "M112 96l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM64 208l-16 0 0 256 288 0 0-256-16 0 0 0-48 0 0 0-160 0 0 0-48 0 0 0zm0-48l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64 64 0 0 352-384 0 0-352 64 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "lock",
  unicode: 0xf023,
};

export { lock };
